import 'core-js';

// import player
import initPlayer from 'website/module/player';
import initPlayerExport from 'website/module/player/export';
// @babel/preset-env will transform that into a set of relevent imports
import pageCommon from 'website/page-common';

// bootstrap the application / store

pageCommon(false).then(() => {
  initPlayer();
  initPlayerExport();
});
